import { subscribeToChatUnread } from "../channels/chat_unread_channel";
import { subscribeToMessageThread, unsubscribeFromMessageThread } from "../channels/message_thread_channel";

export default function registerChat(Alpine) {
  Alpine.store("chat", {
    isOpen: false,
    unreadCount: 0
  });

  Alpine.data("chatPanel", () => ({
    activeThreadId: null,
    showNewForm: false,

    init() {
      this.fetchUnreadCount();
      subscribeToChatUnread(Alpine);

      // Auto-open thread from notification link
      const url = new URL(window.location);
      const openThread = url.searchParams.get("open_thread");
      if (openThread) {
        url.searchParams.delete("open_thread");
        window.history.replaceState({}, "", url);
        this.$store.chat.isOpen = true;
        this.$nextTick(() => this.openThread(openThread));
      }

      this._streamHandler = (event) => {
        const target = event.target;
        if (target.getAttribute("target") === "chat-messages") {
          requestAnimationFrame(() => {
            const container = document.getElementById("chat-messages");
            if (container) container.scrollTop = container.scrollHeight;
          });
        }
      };
      document.addEventListener("turbo:before-stream-render", this._streamHandler);
    },

    destroy() {
      if (this._streamHandler) document.removeEventListener("turbo:before-stream-render", this._streamHandler);
      unsubscribeFromMessageThread();
    },

    toggle() {
      this.$store.chat.isOpen = !this.$store.chat.isOpen;
      if (this.$store.chat.isOpen) {
        this.showNewForm = false;
        this.activeThreadId = null;
        unsubscribeFromMessageThread();
        this.loadThreadList();
        // Close agent panel if open
        if (this.$store.agentPanel) this.$store.agentPanel.isOpen = false;
      }
    },

    closePanel() {
      this.$store.chat.isOpen = false;
      this.activeThreadId = null;
      this.showNewForm = false;
      unsubscribeFromMessageThread();
    },

    async fetchUnreadCount() {
      try {
        const response = await fetch("/messages/unread_count", {
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        });
        if (response.ok) {
          const data = await response.json();
          this.$store.chat.unreadCount = data.count;
        }
      } catch {
        // Silently fail on fetch errors
      }
    },

    loadThreadList() {
      const frame = document.getElementById("chat-thread-list");
      if (frame) {
        frame.src = "/message_threads";
      }
    },

    openThread(threadId) {
      this.activeThreadId = threadId;
      this.showNewForm = false;
      const frame = document.getElementById("chat-thread-detail");
      if (frame) {
        frame.src = `/message_threads/${threadId}`;
      }

      // Subscribe to real-time messages for this thread
      const userMeta = document.querySelector('meta[name="current-user-id"]');
      const currentUserId = userMeta ? userMeta.content : null;
      subscribeToMessageThread(threadId, currentUserId);
    },

    handleThreadCreated(event) {
      const threadId = event.detail?.id;
      if (threadId) {
        this.openThread(threadId);
      }
    },

    backToList() {
      this.activeThreadId = null;
      this.showNewForm = false;
      unsubscribeFromMessageThread();
      this.loadThreadList();
    },

    openNewForm() {
      this.showNewForm = true;
      this.activeThreadId = null;
      unsubscribeFromMessageThread();
    },

    async openForRecord(detail) {
      const { type, id, name, typeLabel } = detail;
      this.$store.chat.isOpen = true;
      this.showNewForm = false;
      this.activeThreadId = null;
      unsubscribeFromMessageThread();

      try {
        const response = await fetch(
          `/messages/find_thread?discussable_type=${encodeURIComponent(type)}&discussable_id=${encodeURIComponent(id)}`,
          { headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } }
        );
        if (response.ok) {
          const data = await response.json();
          if (data.thread_id) {
            this.openThread(data.thread_id);
            return;
          }
        }
      } catch {
        // Fall through to new form
      }

      // No existing thread — open new form pre-filled
      this.showNewForm = true;
      this.$nextTick(() => {
        window.dispatchEvent(new CustomEvent("prefill-new-thread", { detail: { type, id, name, typeLabel } }));
      });
    }
  }));
}
